
import {labelsummaryconfig,getByDcUuid} from '@/services/internal/facility/config/labelsummaryconfig'


export default {
    namespace: 'labelTpickContainerTypeConfig',
  
    state: {
      data: {},
    },
  
    effects: {
        *getByDcUuid({payload,callback},{call,put}){
          const response = yield call(getByDcUuid, payload);
          if(response&&response.success){
            yield put({
              type: 'save',
              payload:  response.data ? response.data : [],
            });
          }
          if(callback) callback(response);
        },
        *labelsummaryconfig({payload,callback},{call,put}){
          const response = yield call(labelsummaryconfig, payload);
          if(callback) callback(response);
        }
    },
  
    reducers: {
      save(state, action) {
        return {
          ...state,
          data: action.payload,
        };
      },
    }
  }
